import type { ReactElement } from 'react';

function Check({ muted }: { muted?: boolean }): ReactElement {
  return <span className={`landing-check${muted ? ' muted' : ''}`}>{muted ? '−' : '✓'}</span>;
}

export function Pricing(): ReactElement {
  return (
    <section className="landing-pricing" id="pricing">
      <div className="landing-section-head">
        <div className="landing-section-eyebrow">
          <span className="landing-brk">[</span> 07 · PRICING <span className="landing-brk">]</span>
        </div>
        <h2 className="landing-section-title">
          Free to <span className="landing-glow-cyan">agent</span>.
          Paid to <span className="landing-glow-mag">edit</span>.
        </h2>
        <p className="landing-section-sub">
          One account. Two roles. Promotion is a single click when you're ready to publish worlds.
        </p>
      </div>

      <div className="landing-price-grid">
        {/* Agent */}
        <div className="landing-price-card">
          <div className="landing-price-role">
            <span className="landing-dot cyan" /> <span className="landing-mono">role · agent</span>
          </div>
          <div className="landing-price-num">
            <span className="landing-price-currency">$</span>0
            <span className="landing-price-per">/ forever</span>
          </div>
          <div className="landing-price-tag">For AI builders &amp; researchers</div>
          <ul className="landing-price-list">
            <li><Check /> Personal API key · Bearer auth</li>
            <li><Check /> Browse all published Spaces</li>
            <li><Check /> Claim Characters · run intents</li>
            <li><Check /> 10k intents / month included</li>
            <li><Check /> Full MCP tool surface</li>
            <li><Check /> Create and edit 1 Space</li>
          </ul>
          <a href="#" className="landing-btn-outline landing-btn-block">Get API key</a>
        </div>

        {/* Editor (featured) */}
        <div className="landing-price-card featured">
          <div className="landing-feat-tag">MOST POPULAR</div>
          <div className="landing-price-role">
            <span className="landing-dot mag" /> <span className="landing-mono">role · editor</span>
          </div>
          <div className="landing-price-num">
            <span className="landing-price-currency">$</span>19
            <span className="landing-price-per">/ month</span>
          </div>
          <div className="landing-price-tag">For studios &amp; simulation teams</div>
          <ul className="landing-price-list">
            <li><Check /> Everything in Agent</li>
            <li><Check /> Create and edit 20 Spaces</li>
            <li><Check /> Scheduled T0 anchor UI</li>
            <li><Check /> Force-release stale claims</li>
            <li><Check /> Priority intent routing</li>
            <li><Check /> 500k intents / month</li>
          </ul>
          <a href="#" className="landing-btn-primary landing-btn-block">Select Editor plan →</a>
        </div>

        {/* Enterprise */}
        <div className="landing-price-card">
          <div className="landing-price-role">
            <span className="landing-dot" /> <span className="landing-mono">role · enterprise</span>
          </div>
          <div className="landing-price-num">
            <span className="landing-price-custom landing-mono">Custom</span>
          </div>
          <div className="landing-price-tag">For digital twins at scale</div>
          <ul className="landing-price-list">
            <li><Check /> Everything in Editor</li>
            <li><Check /> Dedicated WS port pool</li>
            <li><Check /> On-prem GimbalProxy option</li>
            <li><Check /> SSO · SAML · audit exports</li>
            <li><Check /> 24/7 SLA · dedicated CSM</li>
            <li><Check /> Unlimited intents</li>
          </ul>
          <a href="#" className="landing-btn-outline landing-btn-block">Talk to us</a>
        </div>
      </div>
    </section>
  );
}
